export const selectorFilter = (state) => state.filter.name;
